import { formatNumber } from 'helper';
import { isUndefined } from 'lodash';

const MAP_APPROVAL_STATUS = {
  APPROVED: 'Approved',
  IN_REVIEW: 'In Review',
  PENDING: 'Pending KYC',
  REJECTED: 'Rejected',
};

export const transformMerchant = (raw) => ({
  id: raw?.uuid,
  name: raw?.name || 'Untitled',
  logo: raw?.logo ? raw?.logo[0]?.url : '',
  env_mode: raw?.status,

  approval_status: raw?.approval_status,
  approval_status_label: MAP_APPROVAL_STATUS[raw?.approval_status],
  approval_remarks: raw?.approval_status_remarks,
  current_step: raw?.current_step ? parseInt(raw?.current_step, 10) : 0,
});

export const transformMerchantSettlement = (raw) => ({
  id: raw?.id || '',
  name: raw?.name || '',
});

export const transformMerchantApiKey = (raw) => ({
  id: raw?.id || '',
  name: raw?.name || '',
});

export const transformGeneralInfo = (raw) => ({
  id: raw?.uuid || '',
  logo: raw?.logo ? raw?.logo[0]?.url : '',
  name: raw?.name || '',
  website_url: raw?.website_url || '',
  industry: raw?.industry || '',
  customer_service_number: raw?.customer_service_number || '',
  email: raw?.email || '',
  // business_address: raw?.business_address || '',
  district: raw?.business_address?.district || '',
  street: raw?.business_address?.street || '',
  house_no: raw?.business_address?.house_no || '',
  building_name: raw?.business_address?.building_name || '',
  unit_no: raw?.business_address?.unit_no || '',
  postal_code: raw?.business_address?.postal_code || '',
  // business_geoloc: raw?.business_geoloc || '',
  business_description: raw?.business_description || '',
  business_number_of_customers: raw?.business_number_of_customers || '',
  business_monthly_sales: raw?.business_monthly_sales || '',
  business_type: raw?.business_type || '',
});

export const transformBusinessCorporation = (raw) => {
  let isBeneficialOwner = '';
  isBeneficialOwner = raw?.is_beneficial_owner || '';
  if (!isUndefined(raw?.is_beneficial_owner)) {
    isBeneficialOwner = raw?.is_beneficial_owner ? 'Yes' : 'No';
  }
  return {
    first_name: raw?.first_name || '',
    last_name: raw?.last_name || '',
    // home_address: raw?.home_address || '',
    district: raw?.home_address?.district || '',
    street: raw?.home_address?.street || '',
    house_no: raw?.home_address?.house_no || '',
    building_name: raw?.home_address?.building_name || '',
    unit_no: raw?.home_address?.unit_no || '',
    postal_code: raw?.home_address?.postal_code || '',
    // home_geoloc: raw?.home_geoloc || '',
    is_beneficial_owner: isBeneficialOwner,
    owner_id_image_url: raw?.owner_id_image_url || [],
    business_legal_name: raw?.business_legal_name || '',
    business_registration_number: raw?.business_registration_number || '',
    business_incorporation_date: raw?.business_incorporation_date || '',
    cert_of_corporation_imge_url: raw?.cert_of_corporation_imge_url || [],
    form_x_image_url: raw?.form_x_image_url || [],
    business_local_director_ic_image_url:
      raw?.business_local_director_ic_image_url || [],
    bank_name: raw?.bank_name || '',
    bank_account_name: raw?.bank_account_name || '',
    bank_account_number: raw?.bank_account_number || '',
  };
};

export const transformBusinessSole = (raw) => ({
  first_name: raw?.first_name || '',
  last_name: raw?.last_name || '',
  // home_address: raw?.home_address || '',
  // home_geoloc: raw?.home_geoloc || null,
  district: raw?.home_address?.district || '',
  street: raw?.home_address?.street || '',
  house_no: raw?.home_address?.house_no || '',
  building_name: raw?.home_address?.building_name || '',
  unit_no: raw?.home_address?.unit_no || '',
  postal_code: raw?.home_address?.postal_code || '',
  owner_id_image_url: raw?.owner_id_image_url || [],
  business_cert_image_url: raw?.business_cert_image_url || [],
  business_local_owner_ic_image_url:
    raw?.business_local_owner_ic_image_url || [],
  business_legal_name: raw?.business_legal_name || '',
  business_registration_number: raw?.business_registration_number || '',
  business_incorporation_date: raw?.business_incorporation_date || '',
  bank_name: raw?.bank_name || '',
  bank_account_name: raw?.bank_account_name || '',
  bank_account_number: raw?.bank_account_number || '',
});

export const transformBusinessIndividual = (raw) => ({
  first_name: raw?.first_name || '',
  last_name: raw?.last_name || '',
  // home_address: raw?.home_address || '',
  // home_geoloc: raw?.home_geoloc || null,
  district: raw?.home_address?.district || '',
  street: raw?.home_address?.street || '',
  house_no: raw?.home_address?.house_no || '',
  building_name: raw?.home_address?.building_name || '',
  unit_no: raw?.home_address?.unit_no || '',
  postal_code: raw?.home_address?.postal_code || '',
  owner_id_image_url: raw?.owner_id_image_url || [],
  business_duration: raw?.business_duration || '',
  bank_name: raw?.bank_name || '',
  bank_account_name: raw?.bank_account_name || '',
  bank_account_number: raw?.bank_account_number || '',
});

export const transformBusinessPartner = (raw) => ({
  first_name: raw?.first_name || '',
  last_name: raw?.last_name || '',
  // home_address: raw?.home_address || '',
  // home_geoloc: raw?.home_geoloc || null,
  district: raw?.home_address?.district || '',
  street: raw?.home_address?.street || '',
  house_no: raw?.home_address?.house_no || '',
  building_name: raw?.home_address?.building_name || '',
  unit_no: raw?.home_address?.unit_no || '',
  postal_code: raw?.home_address?.postal_code || '',
  owner_id_image_url: raw?.owner_id_image_url || null,
  business_legal_name: raw?.business_legal_name || '',
  business_registration_number: raw?.business_registration_number || '',
  business_incorporation_date: raw?.business_incorporation_date || '',
  sec_cert_of_partnership_image_url:
    raw?.sec_cert_of_partnership_image_url || null,
  art_of_partnership_image_url: raw?.art_of_partnership_image_url || null,
});

export const transformBusinessGovernment = (raw) => ({
  first_name: raw?.first_name || '',
  last_name: raw?.last_name || '',
  district: raw?.home_address?.district || '',
  street: raw?.home_address?.street || '',
  house_no: raw?.home_address?.house_no || '',
  building_name: raw?.home_address?.building_name || '',
  unit_no: raw?.home_address?.unit_no || '',
  postal_code: raw?.home_address?.postal_code || '',
  owner_id_image_url: raw?.owner_id_image_url || [],
  government_ministry: raw?.government_ministry || '',
  date_of_government_official_letter:
    raw?.date_of_government_official_letter || '',
  government_official_letter_refno: raw?.government_official_letter_refno || '',
  authorised_name_of_contact_person:
    raw?.authorised_name_of_contact_person || '',
  authorised_contact_person_ic_no: raw?.authorised_contact_person_ic_no || '',
  ministry_appointment_letter_img_url:
    raw?.ministry_appointment_letter_img_url || [],
  ministry_letter_for_appointed_img_url:
    raw?.ministry_letter_for_appointed_img_url || [],
  ic_authorised_person_img_url: raw?.ic_authorised_person_img_url || [],
  bank_name: raw?.bank_name || '',
  bank_account_name: raw?.bank_account_name || '',
  bank_account_number: raw?.bank_account_number || '',
});

export const transformBusinessInfo = (data, type) => {
  switch (type) {
    case 'CORPORATION':
      return transformBusinessCorporation(data);
    case 'SOLE_PROPRIETORSHIP':
      return transformBusinessSole(data);
    case 'INDIVIDUAL':
      return transformBusinessIndividual(data);
    default:
      return transformBusinessGovernment(data);
  }
};

/* MERCHANT CATEGORY & CHANNEL ATTACHMENT START */
export const transformAttachedPaymentCategory = (raw) => ({
  id: raw?.uuid,
  logo: raw?.logo,
  name: raw?.name,
  status: raw?.status,
  code: raw?.code,
});

export const transformAttachedPaymentChannel = (raw) => ({
  id: raw?.uuid,
  logo: raw?.logo,
  name: raw?.name,
  status: raw?.status,
  sequence: raw?.sequence,
  payment_channel_fees: raw?.payment_channel_fees,
  code: raw?.code || '',
});

export const transformChannelOptions = (raw) => ({
  id: raw?.uuid,
  name: raw?.name || '',
  logo: raw?.logo || '',
  code: raw?.code || '',
});
/* MERCHANT CATEGORY & CHANNEL ATTACHMENT END */

/* SETTLEMENT */
export const transformBillerSettlementList = (raw) => ({
  id: raw?.uuid || '',
  merchant_id: raw?.merchant_uuid || '',
  merchant_details: raw?.merchant_details || {},
  date_request: raw?.date_requested || '',
  request_ref_no: raw?.request_ref_no || '',
  amount_request: `B$${formatNumber(raw?.amount, 2)}` || '',
  settlement_status: raw?.status || '',
  date_received_settlement: raw?.date_received_settlement || '',
  settlement_ref_no: raw?.settlement_ref_no || '',
  accumulated_amount: `B$${formatNumber(raw?.accumulated_amount, 2)}` || '',
  proof_of_payment: raw?.attachment_url || [],
  approved_at: raw?.approved_at || '',
  requested_by: raw?.requestor?.name,
  settled_by: raw?.approver?.name,
});

export const transformSelectedBillerSettlement = (raw) => ({
  id: raw?.uuid || '',
  merchant_id: raw?.merchant_uuid || '',
  merchant_details: raw?.merchant_details || {},
  date_request: raw?.date_requested || '',
  request_ref_no: raw?.request_ref_no || '',
  amount_request: `B$${formatNumber(raw?.amount, 2)}` || '',
  settlement_status: raw?.status || '',
  date_received_settlement: raw?.date_received_settlement || '',
  settlement_ref_no: raw?.settlement_ref_no || '',
  accumulated_amount: `B$${formatNumber(raw?.accumulated_amount, 2)}` || '',
  proof_of_payment: raw?.attachment_url || [],
  approved_at: raw?.approved_at || '',
  requested_by: raw?.requestor?.name,
  settled_by: raw?.approver?.name,
});
/* SETTLEMENT END */
